import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {
	init() {

		function GetInChargeBenefits( container ) {

			var controller = new ScrollMagic.Controller();

			var scene = new ScrollMagic.Scene({triggerElement: container, triggerHook: 0.9 })
				// trigger animation by adding a css class
				.setClassToggle(container, "load")
				// .addIndicators({name: "- ChargeBenefits "}) // add indicators (requires plugin)
				.addTo(controller);	

		}

		var container = document.querySelectorAll('.chargeBenefits');

		if( container.length == 1 ) {

			GetInChargeBenefits( container[0] );

		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
